import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery } from "react-query";
import env from "../../environment";

export function useEagleTracker({ event, year }) {
  const { data, isLoading, refetch } = useQuery(
    ["eagleQual", event, year],
    () =>
      makeAuthedRequest(
        `/eagle/event/${event}/year/${year}`,
        {
          method: "GET",
        },
        env.apiBase
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
